import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import { Sigil } from "@/components/temple/Sigil";
import { API_BASE } from "@/lib/apiBase";

const API = API_BASE;
const COPY = {
  confirmed: ["Your yes is received.", "Each Sunday morning, a gentle reminder will call you back to your current gate."],
  unsubscribed: ["You have been released.", "No more reminders will be sent. The temple remains open whenever you return."],
  "not-found": ["Already released.", "This reminder was already removed."],
  error: ["This link has faded.", "It may have expired or already been used."],
};

export default function Reminders() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  useEffect(() => {
    const action = params.get("action");
    const token = params.get("token") ?? "";
    if (!["confirm", "unsubscribe"].includes(action) || token.length < 20) {
      setState("error");
      return undefined;
    }
    let alive = true;
    axios
      .post(`${API}/reminders/${action}`, { token })
      .then((r) => alive && setState(r.data?.status ?? "error"))
      .catch(() => alive && setState("error"));
    return () => {
      alive = false;
    };
  }, [params]);

  const [title, body] = COPY[state] ?? ["Listening…", ""];
  return (
    <main data-testid="reminders-page" className="min-h-[80vh] flex items-center justify-center px-5 pt-24 text-center">
      <div className="max-w-xl">
        <Sigil animate className="w-16 h-16 mx-auto" width={2.5} />
        <h1 data-testid="reminders-title" className="font-display text-4xl sm:text-6xl mt-10 leading-[1.05]">{title}</h1>
        <p className="mt-6 text-lg text-[#CFC2B6]">{body}</p>
        <Link to="/journey" className="mt-10 inline-flex rounded-full border border-[#D9B47A]/60 px-6 py-3 font-tt-mono text-[12px] uppercase tracking-[0.2em] hover:bg-[#D9B47A] hover:text-[#0A0706] transition-colors">
          Open my journey
        </Link>
      </div>
    </main>
  );
}
